"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEligibilityTestMiscAvailableFieldProposals = exports.createEligibilityEvaluator = exports.checkEligibilityConfigErrors = exports.EligibilityTestMiscAvailableFields = exports.EligibilityTestMiscAvailableFieldConfigs = void 0;
const lodash_1 = __importDefault(require("lodash"));
const common_1 = require("@finley-technologies/common");
const finley_types_1 = require("@finley-technologies/finley-types");
const formula_engine_1 = require("@finley-technologies/formula-engine");
const RequiredIntermediateFields_1 = require("./RequiredIntermediateFields");
exports.EligibilityTestMiscAvailableFieldConfigs = {
    'loanTapeMetadata.reportingDate': {
        label: 'loanTapeMetadata.reportingDate',
        description: 'Loan tape reporting date (loan tape metadata)',
    },
};
exports.EligibilityTestMiscAvailableFields = Object.keys(exports.EligibilityTestMiscAvailableFieldConfigs);
/**
 * Eligibility formulas can use variables from baseFields and intermediate calcs.
 * This functions checks for any missing dependencies found in eligibility formulas.
 */
const checkEligibilityConfigErrors = ({ eligibilityCalcs, intermediateCalcs, baseFields, }) => {
    const dynamicIntermediateFields = intermediateCalcs
        .map((intermediateCalc) => intermediateCalc.field)
        .filter((field) => !RequiredIntermediateFields_1.RequiredIntermediateFieldNames.includes(field));
    const baseFieldVars = baseFields.map((fieldConfig) => `baseFields.${fieldConfig.field}`);
    const dynamicFieldVars = dynamicIntermediateFields.map((key) => `dynamicIntermediateFields.${key}`);
    const requiredFieldVars = RequiredIntermediateFields_1.RequiredIntermediateFieldNames.map((key) => `requiredIntermediateFields.${key}`);
    const loanTapeMetaDataVars = ['loanTapeMetadata.reportingDate'];
    const availableVariables = new Set([
        ...baseFieldVars,
        ...dynamicFieldVars,
        ...requiredFieldVars,
        ...loanTapeMetaDataVars,
    ]);
    // generate formula dependencies for each field
    const errorsPerField = eligibilityCalcs.map((eligibility) => {
        (0, common_1.finleyAssert)(eligibility.type === 'formula', 'eligibility calc only support formulas');
        const formulaErrors = (0, formula_engine_1.getFormulaErrors)(eligibility.config.formula, availableVariables);
        return {
            propertyKey: eligibility.propertyKey,
            ...formulaErrors,
        };
    });
    // filter out things that are not really missing.
    const definitelyMissing = errorsPerField.filter(({ errorMessages }) => errorMessages.length > 0);
    return definitelyMissing;
};
exports.checkEligibilityConfigErrors = checkEligibilityConfigErrors;
const createEligibilityEvaluator = (eligibilityConfigs, f1EngineMode) => {
    // extract formulas from the config.
    // instantiate FormulaEngine with all formula strings
    // we need to do this upfront to ensure that formula's AST are cached.
    const formulaStrings = eligibilityConfigs
        .filter((config) => config.type === 'formula')
        .map((config) => {
        (0, common_1.finleyAssert)(config.type === 'formula', 'keep TS happy');
        (0, common_1.finleyAssert)(config.config.engineVersion ===
            finley_types_1.FormulaEngine.SupportedFormulaEngines.HyperFormula1, `${config.config.engineVersion} is not yet supported`);
        return config.config.formula;
    });
    const formulaEngine = (0, formula_engine_1.createFormulaEngine)(finley_types_1.FormulaEngine.SupportedFormulaEngines.HyperFormula1, formulaStrings, f1EngineMode);
    const setVariables = (inputFields) => {
        formulaEngine.setVariables(inputFields, { flatten: true });
    };
    const evaluateConfig = (config, waiveConfig) => {
        (0, common_1.finleyAssert)(config.type === 'formula', `${config.type} is not yet supported`);
        (0, common_1.finleyAssert)(config.config.engineVersion ===
            finley_types_1.FormulaEngine.SupportedFormulaEngines.HyperFormula1, `${config.config.engineVersion} is not yet supported`);
        const isEligible = formulaEngine.evaluateBoolean(config.config.formula);
        const areAllEligibilityKeysWaivedForReceivable = waiveConfig.waiveAllEligibility;
        const isSpecificEligibilityKeyWaivedForReceivable = waiveConfig.waivedEligibilityTestKeysForReceivable.has(config.propertyKey);
        const isWaived = areAllEligibilityKeysWaivedForReceivable ||
            isSpecificEligibilityKeyWaivedForReceivable;
        if (isEligible) {
            return 'ELIGIBLE';
        }
        if (isWaived) {
            return 'INELIGIBLE_WAIVED';
        }
        return 'INELIGIBLE';
    };
    return {
        evaluateConfig,
        setVariables,
    };
};
exports.createEligibilityEvaluator = createEligibilityEvaluator;
const createEligibilityTestMiscAvailableFieldProposals = () => {
    return lodash_1.default.map(exports.EligibilityTestMiscAvailableFieldConfigs, ({ label, description }) => ({
        label,
        documentation: description,
        insertText: label,
    }));
};
exports.createEligibilityTestMiscAvailableFieldProposals = createEligibilityTestMiscAvailableFieldProposals;
//# sourceMappingURL=eligibilityEvaluator.js.map